/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TestProxy, TestProxyInterface } from "../TestProxy";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
    ],
    name: "Test",
    type: "event",
  },
  {
    inputs: [],
    name: "getTrustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "test",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "func",
        type: "bytes",
      },
    ],
    name: "execute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TestProxyConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestProxyConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestProxy__factory extends ContractFactory {
  constructor(...args: TestProxyConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    forwarder: string,
    overrides?: Overrides & { from?: string }
  ): Promise<TestProxy> {
    return super.deploy(forwarder, overrides || {}) as Promise<TestProxy>;
  }
  override getDeployTransaction(
    forwarder: string,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(forwarder, overrides || {});
  }
  override attach(address: string): TestProxy {
    return super.attach(address) as TestProxy;
  }
  override connect(signer: Signer): TestProxy__factory {
    return super.connect(signer) as TestProxy__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestProxyInterface {
    return new utils.Interface(_abi) as TestProxyInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestProxy {
    return new Contract(address, _abi, signerOrProvider) as TestProxy;
  }
}
